import React from 'react';
import PropTypes from 'prop-types';
import randomstring from 'uuid/v4';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { intlShape, injectIntl } from 'react-intl';

import { SearchIcon } from '../../../images/icons/WrapSvg';
import Table from '@material-ui/icons/TableChart';
import List from '@material-ui/icons/List';
import VisibilityICon from '@material-ui/icons/Visibility';
import StarIcon from '@material-ui/icons/Star';
import EmployeeIcon from '@material-ui/icons/Face';


import * as actions from '../../../actions/process.inventory.actions';

import Item from './MenuItem';

class Menu extends React.Component {
    state = {
        options: [
            {
                primary: 'visibility_menu',
                icon: <VisibilityICon />,
                link: 'controlpanel',
                permits: [20, 82],
                licenses: [150]
            },
            {
                primary: 'report_search_values',
                icon: <SearchIcon />,
                link: 'search',
                permits: [20, 60],
                licenses: [150]
            },
            {
                primary: 'report_search_lot_temp',
                icon: <SearchIcon />,
                link: 'lot',
                permits: [20, 60],
                licenses: [150]
            },
            {
                primary: 'report_sts_menu',
                icon: <StarIcon />,
                link: 'sts',
                permits: [20, 83],
                licenses: [157]
            },
            {
                primary: 'manage_decrease_menu',
                icon: <Table />,
                link: 'decrease',
                permits: [20, 60],
                licenses: [154]
            },
            {
                primary: 'manage_appcc_menu',
                icon: <List />,
                link: 'appcc',
                permits: [20, 60],
                licenses: [150]
            },
            {
                primary: 'employee',
                icon: <EmployeeIcon />,
                link: 'employee',
                permits: [20, 86],
                licenses: [150]
            },
        ],
    };

    handleClose = (id, url, e) => {
        this.props.setInventoryWindow(id);
        this.props.history.push('/reports/' + url);
    };

    render() {
        const { info, active } = this.props;
        const { options } = this.state;
        const data = options
            .filter(
                (f) =>
                    info &&
                    info.security &&
                    info.security.totalPermits &&
                    info.security.totalPermits.some((p) => f.permits.some((s) => s.toString() === p.toString()) ) &&
                    info.security.licencias.some((l) => f.licenses.some((f) => f === l.id && l.activo))
            );
        return (
            data.map((link, index) => (
                <Item
                    key={randomstring()}
                    active={active === link.link}
                    primary={link.primary}
                    onClick={(e) => this.handleClose(index, link.link, e)}
                    icon={link.icon}
                    last={data.length === index + 1}
                />
            ))
        );
    }
}

Menu.propTypes = {
    history: PropTypes.object.isRequired,
    intl: intlShape.isRequired,
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, actions), dispatch);
}

function mapStateToProps(state) {
    return {
        info: state.info,
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(injectIntl(withRouter(Menu)));



// WEBPACK FOOTER //
// ./src/components/complex/reports/Menu.js